<template>
  <div class="custom-select">
    <div class="block-dropdown">
      <select @change="selectOption($event)">
        <option
          v-for="(option, i) in options.values"
          :key="i"
          :selected="selected.includes(option)"
        >
          {{ option }}
        </option>
      </select>
      <svg width="13" height="7" viewBox="0 0 13 7" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13 -1.19209e-07L6.5 7L0 -1.19209e-07L13 -1.19209e-07Z" fill="currentColor"/>
      </svg>
    </div>
  </div>
</template>
<script>
export default {
  name: "VariantCustomSelect",
  props: {
    options: Object,
    selected: Array,
  },
  mounted() {},
  methods: {
    selectOption(e) {
      this.$emit("dropdownselection", e.target.value);
    },
  },
};
</script>
<style scoped>

.block-dropdown {
  position: relative;
}
.block-dropdown:hover svg {
  color: #fff;
}
select {
  border: 1px solid #000000;
  border-radius: 4px;
  padding: 23px 10px;
  margin-bottom: 0;
  color: #3a3830;
  font-size: 18px;
  font-weight: 500;
  line-height: 17px;
  text-align-last: center;
  width: 100%;
  max-width: 100%;
  display: block;
  margin-bottom: 0.75em;
  background-color: transparent;
  outline: 0;
  appearance: none;
  background-position: right center;
  background-image: none;
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-color: transparent;
  text-indent: 0.01px;
  cursor: pointer;
  box-shadow: none;
  transition: 0.2s ease-in-out;
}
select:hover {
  background-color: #3a3830;
  color: #fff;
}
select:hover + svg {
  color: #fff;
}
select + svg {
  position: absolute;
  top: calc(50% - 3px);
  right: 16px;
  color: #7c7473;
}
</style>
